import {
  ChatFragment,
  ChatInsertUserMutation,
  ChatInsertUserMutationVariables,
  ChatMessagesQuery,
  ChatMessagesQueryVariables,
  ChatParticipantsPrivateQueryVariables,
  PrivateChatFragment,
  StudentFragment,
  ChatInsertByTypeGroupMutationVariables,
} from '@school_ify/schoolify-repository/src/shared/types';
import { teacherCreateChatGroup } from '@school_ify/schoolify-repository/src/teacher/repositories/chatRepository';
import {
  createChatPrivate,
  getChatMessages,
  getChatWithParticipant,
  getGroupChats,
  getPrivateChats,
} from '@school_ify/schoolify-repository/src/shared/repositories/chatRepository';
import {
  togglePinMessage,
  studentOrTeacherAddChatUsers,
} from '@school_ify/schoolify-repository/src/student_teacher/repositories/chatRepository';
import { getMyClassStudents } from '@school_ify/schoolify-repository/src/shared/repositories/classRespository';
import {
  StudentOrTeacherChatInsertUsersMutationVariables,
  StudentOrTeacherTogglePinMessageMutationVariables,
} from '@school_ify/schoolify-repository/src/student_teacher/types';

class ChatService {
  public async getGroupChats(): Promise<Array<ChatFragment>> {
    try {
      const rooms = await getGroupChats();
      return rooms;
    } catch (err) {
      return err;
    }
  }

  public async createTeacherGroupChat(
    data: ChatInsertByTypeGroupMutationVariables
  ): Promise<ChatFragment> {
    try {
      const chat = await teacherCreateChatGroup(data);
      return chat;
    } catch (err) {
      return err;
    }
  }

  public async addParticipantToGroupdChat(
    data: StudentOrTeacherChatInsertUsersMutationVariables
  ): Promise<number> {
    try {
      const participants = await studentOrTeacherAddChatUsers(data);
      return participants;
    } catch (err) {
      return err;
    }
  }

  public async getPossibleParticipants(): Promise<Array<PrivateChatFragment>> {
    try {
      const possibleParticipants = await getPrivateChats();
      return possibleParticipants;
    } catch (err) {
      return err;
    }
  }

  public async getGroupChatPossibleParticipants(): Promise<Array<StudentFragment>> {
    try {
      const possibleParticipants = await getMyClassStudents();
      return possibleParticipants;
    } catch (err) {
      return err;
    }
  }

  public async checkIfActiveChatExist(data: ChatParticipantsPrivateQueryVariables): Promise<any> {
    try {
      const exist = await getChatWithParticipant(data);
      return exist;
    } catch (err) {
      return err;
    }
  }

  public async createPrivateChat(
    data: ChatInsertUserMutationVariables
  ): Promise<Readonly<ChatInsertUserMutation>> {
    try {
      const possibleParticipants = await createChatPrivate(data);
      // @ts-ignore
      return possibleParticipants;
    } catch (err) {
      return err;
    }
  }

  public async getPreviousMessages(data: ChatMessagesQueryVariables): Promise<ChatMessagesQuery> {
    const res = await getChatMessages(data);
    return res;
  }

  public async pinMessages(
    data: StudentOrTeacherTogglePinMessageMutationVariables
  ): Promise<number> {
    try {
      const participants = await togglePinMessage(data);
      // @ts-ignore
      return participants;
    } catch (err) {
      return err;
    }
  }
}

export default new ChatService();
